export function _forAttribute(element) {
  if (element.id) {
    return document.querySelector(`label[for="${element.id}"]`);
  }
}

export function _wrappingLabel(element) {
  return element?.closest("label");
}

export function _previousSibling(element) {
  let sibling = element.previousElementSibling;

  while (sibling) {
    if (sibling.tagName.toLowerCase() === "label") {
      return sibling;
    }
    sibling = sibling.previousElementSibling;
  }
}

export function _parentContainer(element) {
  const parent = element.parentElement;
  return parent?.querySelector("label");
}

export function _gridContainer(element) {
  const selectors = [
    ".hq-col-span-4",
    ".hq-col-span-6",
    ".hq-col-span-12",
    ".form-group",
    ".field",
    ".input-group"
  ];

  for (const selector of selectors) {
    const container = element.closest(selector);
    if (container) {
      const label = container.querySelector("label");
      if (label) {
        return label;
      }
    }
  }
}

export function _ariaLabelledby(element) {
  if (element.hasAttribute("aria-labelledby")) {
    const labelId = element.getAttribute("aria-labelledby");
    return document.getElementById(labelId);
  }
}

export function _legendForGroup(element) {
  const fieldset = element.closest("fieldset");
  if (fieldset) {
    return fieldset.querySelector("legend");
  }
}

export function findAssociatedLabelOrLegend(element) {
  const inputTypesWithLegend = ["checkbox", "radio", "file"];
  const type = element.type;

  if (inputTypesWithLegend.includes(type)) {
    const legend = _legendForGroup(element);
    if (legend) {
      return legend.innerText.trim();
    }
  }

  for (const strategy of [
    _forAttribute,
    _ariaLabelledby,
    _wrappingLabel,
    _previousSibling,
    _parentContainer,
    _gridContainer
  ]) {
    const label = strategy(element);
    if (label) return label.innerText.trim();
  }

  return null;
}
